import { isDefined, isBoolean, allOf, anyOf, parseInt10, parseStrIntToInt, truthy } from '../../../utils/util';
import StatModel from './StatModel';

class Header {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      wrap: null,
      data: null,
      model: null,
      global: window
    }, options);

    _.data = _.option.data;

    _.model = StatModel.getInstance();

    _.wrap = null;

    _.levelField = null;

    _.remainStatField = null;

    _.remainTotalStatField = null;

    _.elixirStatField = null;

    _.elixirTotalStatField = null;

    _.elixirStatCheckBox = null;

    _.levelUpBtn = null;

    _.tooltipIntroduceShortcut = null;

    _.isShowedTooltipIntroduceShortcut = false;

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    _.levelField = $('.level > strong', _.wrap);

    _.remainStatField = $('.point p:first .em', _.wrap);

    _.remainTotalStatField = $('.point p:first .total', _.wrap);

    _.elixirStatField = $('.point .elixir var strong', _.wrap);

    _.elixirTotalStatField = $('.point .elixir .total', _.wrap);

    _.elixirStatCheckBox = $('#ELIXIR_POINT', _.wrap);

    _.levelUpBtn = $('.btn-levelup', _.wrap);

    _.tooltipIntroduceShortcut = $('.tooltip-levelup', _.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    if (isDefined(_.data)) {
      if (isDefined(_.data.level)) _.setLevel(_.data.level);

      (allOf(isBoolean(_.data.elixirUseYN), truthy(_.data.elixirUseYN))) ? _.setElixirStatCheckBoxChecked(true) : _.setElixirStatCheckBoxChecked(false);

      if (anyOf(parseInt10(_.data.remainStat) > 0, parseInt10(_.data.remainTotalStat) <= 0)) _.setLevelUpBtnUsable(false);


      if(parseInt10(_.data.level) >= parseInt10(_.data.targetLevel)) {
        _.setLevelUpBtnUsable(false);
      }

    }

    _.setBtns();

    _.setElixirStatCheckBoxEvent();

    if (_.model.DEVICE_TYPE === 'mobile') {
      // phone or tablet
      _.showTooltipOnlyOnce(false);
    }
  }

  showTooltipOnlyOnce(flag) {
    const _ = this;

    if (truthy(flag)) {
      if (truthy(_.isShowedTooltipIntroduceShortcut)) return;
      _.isShowedTooltipIntroduceShortcut = true;

      _.tooltipIntroduceShortcut.show();

    } else {
      _.tooltipIntroduceShortcut.hide();
    }
  }

  setBtns() {
    const _ = this,
      $_ = $(_);

    _.levelUpBtn.on('click', function (evt) {
      evt.preventDefault();

      $_.trigger({type: Header.EVT_LEVEL_UP});
    });
  }

  setElixirStatCheckBoxEvent() {
    const _ = this,
      $_ = $(_);

    _.elixirStatCheckBox.on('change', function (evt) {
      (truthy(_.isCheckedElixirStatCheckBox())) ? _.setElixirStatCheckBoxChecked(true) : _.setElixirStatCheckBoxChecked(false);

      $_.trigger({type: Header.EVT_CHECK_ELIXIR_CHECKBOX});
    });
  }

  setLevel(level) {
    this.levelField.text(level);
  }

  setHpMp(stats) {
    const _ = this;

    if (isDefined(stats.HP)) {
      const hp = (parseStrIntToInt(stats.HP) <= 0) ? '-' : stats.HP;
      $('.hp var', _.wrap).text(hp);
    }

    if (isDefined(stats.MP)) {
      const mp = (parseStrIntToInt(stats.MP) <= 0) ? '-' : stats.MP;
      $('.mp var', _.wrap).text(mp);
    }
  };

  setRemainStat(point) {
    this.remainStatField.text(point);
  }

  setRemainTotalStat(point) {
    this.remainTotalStatField.text(`(${point})`);
  }

  setElixirStat(point) {
    this.elixirStatField.text(point);
  }

  setElixirTotalStat(point) {
    this.elixirTotalStatField.text(`(${point})`);
  }

  setAllStats(statData = {}) {
    const _ = this;

    _.setRemainStat(statData.remainStat);
    _.setRemainTotalStat(statData.remainTotalStat);
    _.setElixirStat(statData.elixirStat);
    _.setElixirTotalStat(statData.elixirTotalStat);
  }

  activateElixirStatField(flag) {
    const _ = this;

    if (_.elixirStatField.length <= 0) return;

    (truthy(flag)) ? _.elixirStatField.addClass('on') : _.elixirStatField.removeClass('on');
  }

  setElixirStatCheckBoxChecked(flag) {
    const _ = this,
      customCheckBox = $('.custom-checkbox', _.wrap);

    if (truthy(flag)) {
      _.elixirStatCheckBox.prop('checked', true);
      customCheckBox.addClass('selected');

    } else {
      _.elixirStatCheckBox.prop('checked', false);
      customCheckBox.removeClass('selected');
    }
  }

  setLevelUpBtnUsable(flag, deviceType) {
    const _ = this;

    if (_.levelUpBtn.length <= 0) return;

    if (truthy(flag)) {
      _.levelUpBtn.attr('disabled', false).addClass('on');

    } else {
      _.levelUpBtn.attr('disabled', true).removeClass('on');
    }

    if (deviceType === 'pc') {
      _.showTooltipOnlyOnce(flag);
    }
  }

  reset(statData = {}) {
    var _ = this;

    if (isDefined(statData.level)) _.setLevel(statData.level);

    (truthy(statData.elixirUseYN)) ? _.setElixirStatCheckBoxChecked(true) : _.setElixirStatCheckBoxChecked(false);

    _.setAllStats(statData);
  }

  isCheckedElixirStatCheckBox() {
    return this.elixirStatCheckBox.prop('checked');
  }

  isUsableLevelUpBtn() {
    return !this.levelUpBtn.prop('disabled');
  }

  destroy(obj = null) {
    const _ = this;

    _.levelUpBtn.off('click');

    _.elixirStatCheckBox.off('change');
  }
}

Header.EVT_LEVEL_UP = 'EVT_LEVEL_UP';
Header.EVT_CHECK_ELIXIR_CHECKBOX = 'EVT_CHECK_ELIXIR_CHECKBOX';

export default Header;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/stat/Header.js